import React, { useState } from 'react';
import { Row, Label, Input } from "reactstrap"


const DPTextBoxforgrid = ({ rowClass, labelText, textType, value, onChange, placeholder, defaultValue, textAlign, maxLength, width, id, disabled, onBlur, fontSize,
    onKeyPress, visibility, myInputSize, backgroundColor, color, ref, titleEnable = false, onKeyDown }) => {
    return (
        <Row className={rowClass}>
            <div className="col-md-12">
                <Input
                    ref={ref}
                    className="form-control-sm"
                    title={titleEnable && value}
                    type={textType}
                    value={value}
                    //onChange={onChange}
                    placeholder={placeholder}
                    defaultValue={defaultValue}
                    style={{ textAlign: textAlign ? textAlign : 'left', fontSize: fontSize, visibility: visibility, width: myInputSize ? myInputSize : '100%', background: backgroundColor ? color ? color : "antiquewhite" : "" }}
                    maxLength={maxLength}
                    width={width}
                    id={id}
                    disabled={disabled}
                    onBlur={onBlur}
                    onKeyPress={onKeyPress}
                    onKeyDown={onKeyDown}
                    onFocus={(e) => {
                        e.target.select()
                    }}
                    onInput={onChange}
                />
            </div>
        </Row>
    );
}

export default DPTextBoxforgrid;